import { Box } from '@mui/material'

// local imports
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { createJobPosting } from 'services/api/modules/recruitment/job-advertisment'
import useOpenClose from 'services/hooks/useOpenClose'
import CreateJobAdModal from '../../recruitment-create-job-ad/components/CreateJobAdModal'

const CreateJobAdsButton = () => {
  //modal
  const createModal = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)
  const successSnackbar = useOpenClose(false)

  //navigate
  const navigate = useNavigate()
  const goToManagePublisDraftJobAds = (id) => {
    navigate(`/app/recruitment/applicant-tracking/job-ads/${id}/draft`, {
      state: {
        id,
      },
    })
  }

  //   button click action
  const handleClick = () => {
    // navigate('/app/recruitment/job-ad')
    createModal.handleOpen()
  }

  //api call
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('getAllJobAds')
    queryClient.resetQueries('getAllJobAds')
  }, [])
  const {
    data: meow,
    mutate: createJobPostingMutate,
    isError: createJobPostingError,
    isSuccess: createJobPostingIsSuccess,
    isLoading: createJobPostingisLoading,
  } = useMutation((value) => createJobPosting(value), {
    onSuccess: (response) => {
      console.log(response)
      goToManagePublisDraftJobAds(response.data.id)
      //  successSnackbar.handleOpen()
    },
    onError: (error) => {
      console.log(error)
      errorSnackbar.handleOpen()
    },
  })
  const onSubmit = (e) => {
    e = {
      ...e,
      job_level_id: '',
      job_background_id: '',
      min_salary: '',
      max_salary: '',
      work_location: '',
      city: '',
      state: '',
      job_advertisement_duration: '',
      job_description: '',
      job_requirement: '',
      grade_requirement: '',
      year_of_experience: '',
      qualification_id: '',
      fresh_grade_placement: 0,
      skill: '',
      course: '',
    }
    createJobPostingMutate(e)
  }

  return (
    <Box gap={2} sx={{ width: '100% ' }}>
      <AdxActionButton
        title="Create new job advertisement"
        description="Post your advertisement to adnexio.jobs here"
        icon="create"
        icon2="arrow_forward_ios"
        iconColor="alternate.main"
        iconBgColor="alternate.light"
        divClick={true}
        onClick={handleClick}
        actionMessage="Create"
        sx={{
          '&:hover': {
            backgroundColor: 'primary.light',
          },
          border: 1,
          borderColor: 'gray-line.main',
          borderRadius: '4.5px',
        }}
      />
      {createModal.isOpen ? (
        <CreateJobAdModal
          onSubmit={onSubmit}
          open={createModal.isOpen}
          onClose={createModal.handleClose}
          handleClose={createModal.handleClose}
          mutate={createJobPostingMutate}
          isLoading={createJobPostingisLoading}
        />
      ) : null}

      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}

      {successSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job ad activated"
          open={successSnackbar.isOpen}
          handleClose={successSnackbar.handleClose}
        />
      ) : null}
    </Box>
  )
}
export default CreateJobAdsButton
